<template>
  <div class="">
    <!-- ==================== [[ PCJ Tag ]] ==================== -->
    <div is="script" type="text/javascript">
      function kpp_tracking_event(category, event, site, abtesting, iscta,
      newgtm) { if (event && category) { if (newgtm) { dataLayer.push({'event':
      'uaevent','eventCategory': category,'eventAction': site,'eventLabel':
      event}); } else { } } }
    </div>

    <!-- NBA_dataLayer_v1 -->
    <div is="script" type="text/javascript">
      var pageName; var _ua = (function(u){ return {
      Tablet:(u.indexOf("windows") != -1 && u.indexOf("touch") != -1 &&
      u.indexOf("tablet pc") == -1) || u.indexOf("ipad") != -1 ||
      (u.indexOf("android") != -1 && u.indexOf("mobile") == -1) ||
      (u.indexOf("firefox") != -1 && u.indexOf("tablet") != -1) ||
      u.indexOf("kindle") != -1 || u.indexOf("silk") != -1 ||
      u.indexOf("playbook") != -1, Mobile:(u.indexOf("windows") != -1 &&
      u.indexOf("phone") != -1) || u.indexOf("iphone") != -1 ||
      u.indexOf("ipod") != -1 || (u.indexOf("android") != -1 &&
      u.indexOf("mobile") != -1) || (u.indexOf("firefox") != -1 &&
      u.indexOf("mobile") != -1) || u.indexOf("blackberry") != -1 }
      })(window.navigator.userAgent.toLowerCase()); if(_ua.Mobile ||
      _ua.Tablet){ pageName = 'access/promotion::YOUR-STORIES/local/B2C/new
      cars//mobile/1CB6A5|1CW8AF|1CH5CL|1CCESY/YOUR-STORIES'; }else{ pageName =
      'access/promotion::YOUR-STORIES/local/B2C/new
      cars//desktop/1CB6A5|1CW8AF|1CH5CL|1CCESY/YOUR-STORIES'; } var dataLayer =
      [{ 'brand':'citroen', 'virtualPageURL':'/cpn/your-stories/',
      'pageName':pageName, 'siteTypeLevel1':'access',
      'siteTypeLevel2':'promotion::YOUR-STORIES', 'siteOwner':'local',
      'siteTarget':'B2C', 'siteFamily':'new cars', 'language':'ja',
      'country':'jp', 'pageCategory':'home page',
      'vehicleModelBodystyle':'1CB6A5|1CW8AF|1CH5CL|1CCESY',
      'vehicleModelBodystyleLabel':'C3|C3 AIRCROSS SUV|GRAND C4 SPACETOURER|C5
      AIRCROSS SUV', }];
    </div>
    <!-- enf of NBA_dataLayer_v1 -->

    <!-- Google Tag Manager PSA_GTM_v2 -->
    <div is="noscript">
      <iframe
        src="//www.googletagmanager.com/ns.html?id=GTM-T8GRQS"
        height="0"
        width="0"
        style="display: none; visibility: hidden;"
      ></iframe>
    </div>
    <div is="script" type="text/javascript" v-html="gtm"></div>
    <!-- End Google Tag Manager PSA_GTM_v2 -->

    <!-- ==================== /[[ PCJ Tag ]] ==================== -->
    <div class="hero">
      <picture>
        <source
          media="(max-width: 767px)"
          type="images/webp"
          srcset="
            ../assets/images-webp/hero-sp.webp    1x,
            ../assets/images-webp/hero-sp@2x.webp 2x
          "
        />
        <source
          type="images/webp"
          srcset="
            ../assets/images-webp/hero.webp    1x,
            ../assets/images-webp/hero@2x.webp 2x
          "
        />
        <source
          media="(max-width: 767px)"
          srcset="
            ../assets/images/hero-sp.jpg    1x,
            ../assets/images/hero-sp@2x.jpg 2x
          "
        />
        <img
          src="../assets/images/hero.jpg"
          srcset="../assets/images/hero.jpg 1x, ../assets/images/hero@2x.jpg 2x"
          alt=""
        />
      </picture>
    </div>
    <section class="l-section lead">
      <div class="lead__textbox">
        <span class="lead__text--primary"
          >シトロエンの数だけ、<span class="m-nowrap">物語がある</span></span
        >
        <p class="lead__text">
          世代を越えて愛され、いろんな人の毎日を走り続けてきたシトロエン。<br />
          その長い歴史の中で、たくさんの素敵な思い出をつくってきました。<br />
          ただのクルマとはちょっと違う。家族のような存在だから、想い入れも強くなる。<br />
          そんな、シトロエンを愛するみんなの声を集めました。<br />
          お気に入りのモデルや、とっておきのエピソードなど、気になるコメントをたっぷりと。<br />
          ファンと心をひとつにしながら、あなたの一台に思いをはせるひとときを、<br
            class="m-pc-only"
          />
          ゆっくりとお楽しみください。
        </p>
      </div>
    </section>
    <section class="l-section voice">
      <div class="m-title voice__title">
        <h2 class="voice__title__item">
          シトロエンを愛する<span class="m-nowrap">みんなの声をみる</span>
        </h2>
      </div>
      <div class="voice__container">
        <div class="voice__arrow--prev" v-on:click="prev()">
          <svg class="voice__arrow__item" version="1.1" viewBox="0 0 9 15">
            <path
              d="M857.425,1451.46a23.922,23.922,0,0,1-5.418,5.33l1.854,2.21a28.569,28.569,0,0,0,7.031-7.17,0.675,0.675,0,0,0,.1-0.37,0.785,0.785,0,0,0-.1-0.37,29.093,29.093,0,0,0-6.928-7.09l-1.908,2.26A24.091,24.091,0,0,1,857.425,1451.46Z"
              transform="translate(-852 -1444)"
            ></path>
          </svg>
        </div>
        <div class="voice__arrow--next" v-on:click="next()">
          <svg class="voice__arrow__item" version="1.1" viewBox="0 0 9 15">
            <path
              d="M857.425,1451.46a23.922,23.922,0,0,1-5.418,5.33l1.854,2.21a28.569,28.569,0,0,0,7.031-7.17,0.675,0.675,0,0,0,.1-0.37,0.785,0.785,0,0,0-.1-0.37,29.093,29.093,0,0,0-6.928-7.09l-1.908,2.26A24.091,24.091,0,0,1,857.425,1451.46Z"
              transform="translate(-852 -1444)"
            ></path>
          </svg>
        </div>
        <slick
          ref="slick01"
          :options="slickOptions01"
          dir="rtl"
          class="voice__group"
        >
          <slide-item
            v-for="(item, index) in this.slideGroup01"
            v-bind:key="index"
            v-bind:url="item.path"
            v-bind:text-message="item.props.text"
            v-bind:writer="item.props.writer"
            v-bind:slide-color="slideColor[index % 4]"
          ></slide-item>
        </slick>
        <slick
          ref="slick02"
          :options="slickOptions02"
          dir="rtl"
          class="voice__group"
        >
          <slide-item
            v-for="(item, index) in this.slideGroup02"
            v-bind:key="index"
            v-bind:url="item.path"
            v-bind:text-message="item.props.text"
            v-bind:writer="item.props.writer"
            v-bind:slide-color="slideColor[(index + 1) % 4]"
          ></slide-item>
        </slick>
        <slick
          ref="slick03"
          :options="slickOptions03"
          dir="rtl"
          class="voice__group"
        >
          <slide-item
            v-for="(item, index) in this.slideGroup03"
            v-bind:key="index"
            v-bind:url="item.path"
            v-bind:text-message="item.props.text"
            v-bind:writer="item.props.writer"
            v-bind:slide-color="slideColor[(index + 2) % 4]"
          ></slide-item>
        </slick>
      </div>
    </section>
    <note-section class="l-section"></note-section>
  </div>
</template>
<script>
import Slick from "vue-slick";
import "../../node_modules/slick-carousel/slick/slick.css";
import SlideItem from "../atoms/SlideItem";
import NoteSection from "../components/NoteSection";
import $ from "jquery";
export default {
  name: "index-page",
  components: {
    Slick,
    SlideItem,
    NoteSection,
  },
  data() {
    return {
      slickOptions01: {
        arrows: false,
        rows: 1,
        autoplay: true,
        centerMode: true,
        slidesToShow: 4.8,
        lazyLoad: "progressive",
        rtl: true,
        responsive: [
          {
            breakpoint: 1366,
            settings: {
              slidesToShow: 3.8,
            },
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2.8,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      },
      slickOptions02: {
        arrows: false,
        rows: 1,
        autoplay: true,
        centerMode: true,
        slidesToShow: 5,
        lazyLoad: "progressive",
        rtl: true,
        responsive: [
          {
            breakpoint: 1365,
            settings: {
              slidesToShow: 4,
            },
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      },
      slickOptions03: {
        arrows: false,
        rows: 1,
        autoplay: true,
        centerMode: true,
        slidesToShow: 4.9,
        lazyLoad: "progressive",
        rtl: true,
        responsive: [
          {
            breakpoint: 1365,
            settings: {
              slidesToShow: 3.9,
            },
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2.9,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      },
      slideColor: ["red", "blue", "green", "brown"],
      gtm:
        "/*<![CDATA[*/(function(w,d,s,l,i){w[l]=w[l]||[]; w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'}); var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:''; j.async=true;j.src='//www.googletagmanager.com/gtm.js?id='+i+dl; f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-T8GRQS'); /*]]>*/",
    };
  },
  methods: {
    next: function () {
      this.$refs.slick01.next();
      this.$refs.slick02.next();
      this.$refs.slick03.next();
    },
    prev: function () {
      this.$refs.slick01.prev();
      this.$refs.slick02.prev();
      this.$refs.slick03.prev();
    },
    reInit: function () {
      var instance = this;
      this.$nextTick(function () {
        instance.$rtefs.slick.reSlick();
      });
    },
    footerMargin: function () {
      $(window).on("load resize", function () {
        var fixedmenuH = $("#sticky").innerHeight();
        $("footer").css("margin-bottom", fixedmenuH + "px");
      });
    },
  },
  created: function () {
    var routes = this.$router.options.routes;
    var aveNum = Math.floor((routes.length - 2) / 3);
    this.slideGroup01 = routes.slice(2, aveNum);
    this.slideGroup02 = routes.slice(aveNum, aveNum * 2);
    this.slideGroup03 = routes.slice(aveNum * 2);
    // console.log(
    //   "Group01",
    //   this.slideGroup01[0],
    //   this.slideGroup01[this.slideGroup01.length - 1]
    // );
    // console.log(
    //   "Group02",
    //   this.slideGroup02[0],
    //   this.slideGroup02[this.slideGroup02.length - 1]
    // );
    // console.log(
    //   "Group03",
    //   this.slideGroup03[0],
    //   this.slideGroup03[this.slideGroup03.length - 1]
    // );
  },
  mounted: function () {
    this.footerMargin();
  },
};
</script>
<style lang="scss">
@import "../assets/css/mixins";
@import "../assets/css/var";
//=====================
// reset
//=====================
//=====================
// modules
//=====================
.l-section {
  overflow: hidden;
  & + & {
    margin-top: 90px;
  }
}
.l-inner {
  margin-left: auto;
  margin-right: auto;
}
.l-col {
  &__wrap {
    // font-size: 0;
    overflow: hidden;
  }
  &__item {
    display: inline-block;
  }
  &__left {
    float: left;
  }
  &__right {
    float: right;
  }
}

.m-title {
  color: $color-primary;
  font-weight: 900;
}
.m-text {
  &__large {
    font-size: 125%;
  }
  &__small {
    font-size: 80%;
  }
  &__primary {
    color: $color-primary;
  }
  &__note {
    font-size: 12px;
    line-height: 2.083333333333333;
  }
}
.m-btn {
  text-align: center;
  &__item {
    width: 100%;
    display: block;
    padding: 26px 30px;
    background-color: $color-primary;
    font-size: 24px;
    position: relative;
    color: #ffffff;
    overflow: hidden;
    @include mq-down {
      font-size: 18px;
    }
    & + & {
      margin-top: 14px;
    }
  }
}
.m-list {
  &__item {
    padding-left: 1em;
    text-indent: -1em;
  }
}

.m-icon {
  top: 0;
  bottom: 0;
  margin: auto;
  position: absolute;
  display: block;
  fill: #fff;
  &__item {
    width: 100%;
    height: 100%;
  }
  &__slideArrow {
    @extend .m-icon;
    width: 28px;
    height: 28px;
    position: absolute;
    fill: $color-primary;
    z-index: 99;
    cursor: pointer;
    &--next {
      @extend .m-icon__slideArrow;
      right: 55px;
      @include mq-down {
        right: 25px;
      }
    }
    &--prev {
      @extend .m-icon__slideArrow;
      left: 55px;
      @include mq-down {
        left: 25px;
      }
    }
  }
  &__btnArrow {
    @extend .m-icon;
    width: 14px;
    height: 24px;
    right: 25px;
  }
}
//=====================
// section indivisual
//=====================
//.hero --------------------
.hero {
  margin-left: -15px;
  margin-right: -15px;
}
//.lead --------------------
.lead {
  &__title {
    font-size: 52px;
    text-align: center;
    line-height: 1;
    margin-bottom: 60px;
    @include mq-down {
      font-size: 8vw;
      margin-top: 15px;
      margin-bottom: 40px;
    }
    &__date {
      font-size: 45px;
      @include mq-down {
        font-size: 8vw;
      }
    }
    &__day {
      font-size: 30px;
      margin-left: 10px;
      @include mq-down {
        font-size: 6vw;
      }
    }
    &__arrow {
      font-family: "citroen";
      margin-left: 15px;
      margin-right: 15px;
      @include mq-down {
        margin-left: 7px;
        margin-right: 7px;
      }
      &__item {
        fill: $color-primary;
        width: 32px;
        height: 28px;
        @include mq-down {
          width: 4vw;
          height: inherit;
        }
      }
    }
  }
  &__textbox {
    text-align: center;
  }
  &__text {
    font-size: 18px;
    line-height: 2;
    @include mq-down {
      font-size: 16px;
      text-align: left;
    }
    &--primary {
      font-size: 26px;
      font-weight: 900;
      margin-bottom: 15px;
      display: inline-block;
      @include mq-down {
        font-size: 20px;
      }
    }
  }
}
//.voice --------------------
.voice {
  background-color: #e8e6e2;
  padding-top: 50px;
  margin: 120px -15px 0 -15px;
  margin-left: -15px;
  margin-right: -15px;
  position: relative;
  &::before {
    content: "";
    display: block;
    width: 100%;
    height: 21px;
    position: absolute;
    top: -21px;
    background-image: url(../assets/images/voice-bg_brown.png);
  }
  &__title {
    text-align: center;
    margin-bottom: 25px;
    &__item {
      font-size: 38px;
      text-shadow: white 6px 0 1px, white -6px 0 1px, white 0 -6px 1px,
        white 0 6px 1px, white 6px 6px 1px, white -6px 6px 1px,
        white 6px -6px 1px, white -6px -6px 1px, white 3px 6px 1px,
        white -3px 6px 1px, white 3px -6px 1px, white -3px -6px 1px,
        white 6px 3px 1px, white -6px 3px 1px, white 6px -3px 1px,
        white -6px -3px 1px;
      @include mq-down {
        font-size: 28px;
      }
    }
  }
  &__container {
    padding: 25px 0 60px;
    position: relative;
  }
  &__wrap {
  }
  &__group {
    & + & {
      margin-top: 20px;
      @include mq-down {
        margin-top: 10px;
      }
    }
  }
  &__arrow {
    padding: 15px;
    background-color: rgba(153, 105, 64, 0.9);
    height: 83%;
    position: absolute;
    z-index: 99;
    top: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    border-radius: 4px 0 0 4px;
    @include mq-down {
      padding: 5px;
    }
    &--prev {
      @extend .voice__arrow;
      transform: rotate(180deg);
      left: 0;
    }
    &--next {
      @extend .voice__arrow;
      right: 0;
    }
    &__item {
      width: 24px;
      height: 38px;
      fill: #ffffff;
      @include mq-down {
        width: 18px;
        height: 29px;
      }
    }
  }
}

//.present --------------------
.present {
  &__title {
    font-size: 36px;
    margin-bottom: 20px;
    text-align: center;
    @include mq-down {
      font-size: 24px;
    }
  }
  &__wrap {
    border: 10px solid $color-primary;
    max-width: 1040px;
  }
  &__content {
    width: 50%;
    padding: 40px 0px 0px 4.901960784313725%;
    vertical-align: middle;
    @include mq-down {
      width: 100%;
      padding: 30px 15px 0 15px;
      margin-bottom: 20px;
    }
  }
  &__textbox {
  }
  &__text {
    font-size: 24px;
    font-weight: 900;
    @include mq-down {
      font-size: 20px;
    }
  }
  &__img {
    width: 47.05882352941176%;
    // margin-left: 2.941176470588235%;
    vertical-align: middle;
    margin-bottom: 43px;
    @include mq-down {
      width: 100%;
      margin-bottom: 0;
    }
  }
  &__label {
    margin-bottom: 20px;
    @include mq-down {
      text-align: center;
    }
    &__item {
      background-color: $color-primary;
      line-height: 1.1;
      font-weight: 900;
      display: inline-block;
      color: #ffffff;
      padding: 6px 20px 0px;
      font-size: 27px;
    }
  }

  &__note {
    margin-top: 30px;
    width: 50%;
    padding: 0px 0px 40px 4.901960784313725%;
    @include mq-down {
      width: 100%;
      padding-bottom: 30px;
    }
  }
  &__caution {
    text-align: center;
    margin-top: 25px;
    &__item {
      text-decoration: underline;
      &--sp-left {
        text-decoration: none;
        @include mq-down {
          text-align: left;
        }
      }
    }
  }
  &__btn {
    max-width: 508px;
    margin-top: 25px;
    font-weight: 900;
  }
}

//=====================
//useful module
//=====================
.m-pc-only {
  @include mq-down {
    display: none;
  }
}
.m-sp-only {
  display: none;
  @include mq-down {
    display: inline-block;
  }
}
.m-nowrap {
  white-space: nowrap;
}
</style>
